import { render, staticRenderFns } from "./launch-menu-create.vue?vue&type=template&id=6bba23b0&"
import script from "./launch-menu-create.vue?vue&type=script&lang=ts&"
export * from "./launch-menu-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports